import React, { useState, useEffect, useRef } from 'react';
import './chatbot-ia.css';

console.log('🚀 CHATBOT SUPER ROBUSTO CARGADO - V2.0');

const DEEPSEEK_API_KEY = 'sk-47f026d044854c029b514d5aad6dae51';
const DEEPSEEK_API_URL = 'https://api.deepseek.com/chat/completions';

// BASE DE DATOS EXPANDIDA CON MÁS DETALLES Y SINÓNIMOS
const SERVICES_DATA = [
  {
    name: "AUTOMATIZACIÓN",
    keywords: ["automatización", "automatizar", "control automático", "domótica", "casa inteligente", "hogar inteligente", "edificio inteligente", "control remoto", "smart home", "casa automatica", "control automatico"],
    description: "Soluciones de automatización integral para empresas y hogares con tecnología de última generación. Control de iluminación, climatización, seguridad y entretenimiento desde un solo dispositivo.",
    whatsappMessage: "Hola, me interesa el servicio de AUTOMATIZACIÓN. ¿Podrían darme más información sobre las soluciones disponibles?",
    route: "/Automatizacion",
    benefits: ["Ahorro energético", "Confort mejorado", "Seguridad integrada", "Control remoto"],
    useCases: ["Residencial", "Comercial", "Industrial"]
  },
  {
    name: "SEGURIDAD ELECTRÓNICA Y CCTV", 
    keywords: ["seguridad", "cctv", "cámaras", "vigilancia", "alarmas", "monitoreo", "circuito cerrado", "videovigilancia", "instalación de cámaras", "cámaras seguridad", "sistema de camaras", "vigilancia 24/7", "camaras de seguridad", "sistema seguridad"],
    description: "Sistemas integrales de vigilancia 24/7 con CCTV de alta definición, alarmas inteligentes, sensores de movimiento y monitoreo remoto desde cualquier dispositivo.",
    whatsappMessage: "Hola, me interesa el servicio de SEGURIDAD ELECTRÓNICA Y CCTV. ¿Podrían asesorarme sobre el sistema más adecuado para instalación de cámaras?",
    route: "/SecurityCctv",
    benefits: ["Monitoreo 24/7", "Acceso remoto", "Alertas inteligentes", "Grabación en la nube"],
    useCases: ["Hogares", "Empresas", "Comercios", "Industrias"]
  },
  {
    name: "REDES Y NETWORKING",
    keywords: ["redes", "networking", "internet", "wifi", "conectividad", "router", "switch", "firewall", "infraestructura", "red empresarial", "conexión internet", "wifi empresarial", "red local"],
    description: "Infraestructura de red robusta, escalable y segura para entornos empresariales. Implementamos soluciones de conectividad de alta velocidad y disponibilidad.",
    whatsappMessage: "Hola, me interesa el servicio de REDES Y NETWORKING. ¿Podrían ayudarme con el diseño de infraestructura?",
    route: "/RedesNetworking",
    benefits: ["Alta velocidad", "Estabilidad", "Seguridad", "Escalabilidad"],
    useCases: ["Oficinas", "Empresas", "Centros educativos", "Comercios"]
  },
  {
    name: "PLATAFORMAS PARA AUTOMATIZACIÓN DE PROCESOS",
    keywords: ["plataformas", "automatización procesos", "software automatización", "workflow", "procesos automáticos", "rpa", "automatización software", "flujos trabajo", "optimización procesos"],
    description: "Plataformas especializadas para automatización de procesos empresariales. Optimizamos flujos de trabajo, reducimos errores y aumentamos la eficiencia operativa.",
    whatsappMessage: "Hola, me interesa el servicio de PLATAFORMAS PARA AUTOMATIZACIÓN DE PROCESOS. ¿Podrían mostrarme casos de éxito?",
    route: "/PLAutomatizacion",
    benefits: ["Eficiencia operativa", "Reducción de errores", "Ahorro de tiempo", "Procesos optimizados"],
    useCases: ["Empresas", "Manufactura", "Servicios", "Logística"]
  },
  {
    name: "ENERGÍA SOLAR",
    keywords: ["energía solar", "solar", "paneles solares", "energía renovable", "ahorro energético", "paneles fotovoltaicos", "energía limpia", "paneles solares", "sistema solar", "energía gratuita"],
    description: "Soluciones sostenibles con tecnología solar avanzada. Reduzca hasta un 80% sus costos energéticos mientras contribuye al cuidado del medio ambiente.",
    whatsappMessage: "Hola, me interesa el servicio de ENERGÍA SOLAR. ¿Podrían cotizarme una instalación?",
    route: "/SolarSystems",
    benefits: ["Ahorro hasta 80%", "Energía limpia", "Retorno de inversión", "Bajo mantenimiento"],
    useCases: ["Residencial", "Comercial", "Industrial", "Agropecuario"]
  },
  {
    name: "PUERTAS DE SEGURIDAD",
    keywords: ["puertas seguridad", "control acceso", "puertas blindadas", "biometría", "rfid", "acceso controlado", "puertas automáticas", "control ingreso", "acceso biometrico"],
    description: "Sistemas de control de acceso de última generación con tecnología biométrica, tarjetas RFID y control remoto para máxima seguridad perimetral.",
    whatsappMessage: "Hola, me interesa el servicio de PUERTAS DE SEGURIDAD. ¿Podrían recomendarme la mejor solución?",
    route: "/Puertas-Seguridad",
    benefits: ["Control total", "Registro de accesos", "Alta seguridad", "Fácil administración"],
    useCases: ["Empresas", "Edificios", "Condominios", "Zonas restringidas"]
  },
  {
    name: "PARQUEADEROS INTELIGENTES",
    keywords: ["parqueaderos", "estacionamiento", "parking", "garaje inteligente", "sensores estacionamiento", "parqueadero automático", "sistema parking", "gestión estacionamiento"],
    description: "Gestión automatizada de estacionamientos con sensores de ocupación, cámaras de reconocimiento, sistemas de pago integrados y reserva online.",
    whatsappMessage: "Hola, me interesa el servicio de PARQUEADEROS INTELIGENTES. ¿Podrían explicarme cómo funciona?",
    route: "/IntelligentParking",
    benefits: ["Optimización espacios", "Control de ingresos", "Experiencia usuario", "Operación automática"],
    useCases: ["Centros comerciales", "Edificios", "Empresas", "Zonas públicas"]
  },
  {
    name: "CÓMPUTO Y VIDEOCONFERENCIA",
    keywords: ["cómputo", "videoconferencia", "equipos computo", "reuniones virtuales", "zoom", "teams", "salas reuniones", "computadores", "equipos", "tecnología oficina", "equipos computación"],
    description: "Equipos y soluciones para comunicación empresarial con tecnología de videoconferencia profesional y equipos de cómputo de alto rendimiento.",
    whatsappMessage: "Hola, me interesa el servicio de CÓMPUTO Y VIDEOCONFERENCIA. ¿Podrían asesorarme sobre equipos?",
    route: "/ComputoVideoConferencia",
    benefits: ["Comunicación efectiva", "Productividad", "Trabajo remoto", "Tecnología actualizada"],
    useCases: ["Oficinas", "Salas juntas", "Home office", "Centros educativos"]
  },
  {
    name: "PANTALLAS EDUCATIVAS",
    keywords: ["pantallas", "educativas", "señalización digital", "pantallas interactivas", "aulas virtuales", "digital signage", "pantallas táctiles", "tecnología educativa", "pantallas enseñanza"],
    description: "Soluciones visuales interactivas para educación y señalización digital. Pantallas táctiles, sistemas de gestión de contenido y experiencias inmersivas.",
    whatsappMessage: "Hola, me interesa el servicio de PANTALLAS EDUCATIVAS. ¿Podrían mostrarme las opciones disponibles?",
    route: "/Pantallas-Señalización",
    benefits: ["Aprendizaje interactivo", "Comunicación visual", "Experiencia inmersiva", "Contenido dinámico"],
    useCases: ["Colegios", "Universidades", "Empresas", "Centros comerciales"]
  },
  {
    name: "SISTEMAS POS",
    keywords: ["pos", "punto de venta", "terminal", "caja registradora", "ventas", "tpv", "punto pago", "sistema punto venta", "caja punto venta", "sistema ventas"],
    description: "Soluciones completas para puntos de venta inteligentes que integran hardware especializado y software de gestión para optimizar operaciones comerciales.",
    whatsappMessage: "Hola, me interesa el servicio de SISTEMAS POS. ¿Podrían recomendarme el sistema ideal para mi negocio?",
    route: "/SistemasPOS",
    benefits: ["Control inventario", "Ventas eficientes", "Reportes automáticos", "Experiencia cliente"],
    useCases: ["Tiendas", "Restaurantes", "Supermercados", "Servicios"]
  },
  {
    name: "LICENCIAMIENTO DE SOFTWARE",
    keywords: ["licenciamiento", "software", "licencias", "microsoft", "antivirus", "sistemas operativos", "office", "windows", "software legal", "licencias originales"],
    description: "Soluciones legales y optimizadas para tu negocio con licencias originales, actualizaciones garantizadas y soporte técnico especializado.",
    whatsappMessage: "Hola, me interesa el servicio de LICENCIAMIENTO DE SOFTWARE. ¿Podrían ayudarme con la legalización?",
    route: "/licenciamiento-software",
    benefits: ["Legalidad", "Soporte oficial", "Actualizaciones", "Seguridad"],
    useCases: ["Empresas", "Emprendedores", "Instituciones", "Usuarios finales"]
  },
  {
    name: "NEGOCIOS DIGITALES - MODALIDAD RENTING CON OPCIÓN DE COMPRA",
    keywords: ["negocios digitales", "renting", "computadores", "servidores", "impresoras", "gestión documental", "leasing tecnológico", "equipos renting", "tecnología renting"],
    description: "Soluciones integrales en modalidad renting con opción de compra. Computadores, servidores, impresoras y sistemas de gestión documental.",
    whatsappMessage: "Hola, me interesa el servicio de NEGOCIOS DIGITALES en modalidad RENTING. ¿Podrían enviarme más información?",
    route: "/NegociosDigitales",
    benefits: ["Baja inversión", "Tecnología actual", "Flexibilidad", "Mantenimiento incluido"],
    useCases: ["Startups", "PYMES", "Empresas", "Profesionales"]
  }
];

// SISTEMA DE CONTEXTO Y MEMORIA
const ChatContextManager = {
  context: {
    lastServiceMentioned: null,
    userNeeds: [],
    conversationHistory: [],
    userType: null, // 'residential', 'commercial', 'enterprise'
    budgetRange: null, // 'low', 'medium', 'high'
    urgency: null // 'low', 'medium', 'high'
  },

  updateContext(userMessage, assistantResponse, detectedService = null) {
    // Actualizar servicio mencionado
    if (detectedService) {
      this.context.lastServiceMentioned = detectedService;
    }

    // Detectar tipo de usuario
    if (!this.context.userType) {
      const message = userMessage.toLowerCase();
      if (message.includes('casa') || message.includes('hogar') || message.includes('residencial') || message.includes('apartamento')) {
        this.context.userType = 'residential';
      } else if (message.includes('empresa') || message.includes('negocio') || message.includes('comercial') || message.includes('oficina')) {
        this.context.userType = 'commercial';
      }
    }

    // Guardar en historial
    this.context.conversationHistory.push({
      user: userMessage,
      assistant: assistantResponse,
      timestamp: new Date()
    });

    // Limitar historial a últimos 10 intercambios
    if (this.context.conversationHistory.length > 10) {
      this.context.conversationHistory.shift();
    }
  },

  getContextSummary() {
    let summary = "Contexto actual:\n";
    
    if (this.context.lastServiceMentioned) {
      summary += `- Último servicio mencionado: ${this.context.lastServiceMentioned.name}\n`;
    }
    
    if (this.context.userType) {
      summary += `- Tipo de usuario: ${this.context.userType}\n`;
    }
    
    if (this.context.userNeeds.length > 0) {
      summary += `- Necesidades identificadas: ${this.context.userNeeds.join(', ')}\n`;
    }

    return summary;
  },

  resetContext() {
    this.context = {
      lastServiceMentioned: null,
      userNeeds: [],
      conversationHistory: [],
      userType: null,
      budgetRange: null,
      urgency: null
    };
  }
};

const DomoticChatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showWelcome, setShowWelcome] = useState(true);
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [detectedService, setDetectedService] = useState(null);
  const [conversationStep, setConversationStep] = useState('initial'); // 'initial', 'qualifying', 'recommending'
  const messagesEndRef = useRef(null);

  // Mostrar mensaje de bienvenida después de 2 segundos
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowWelcome(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  // Scroll al final
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  // DETECCIÓN MEJORADA DE SERVICIOS CON ALGORITMO INTELIGENTE
  const detectService = (userMessage) => {
    const messageLower = userMessage.toLowerCase();
    let bestMatch = null;
    let highestScore = 0;

    SERVICES_DATA.forEach(service => {
      let score = 0;
      
      // Coincidencia exacta de palabras clave
      service.keywords.forEach(keyword => {
        const regex = new RegExp(`\\b${keyword}\\b`, 'i');
        if (regex.test(userMessage)) {
          score += 3; // Alta puntuación por coincidencia exacta
        } else if (messageLower.includes(keyword)) {
          score += 1; // Puntuación menor por coincidencia parcial
        }
      });

      // Bonus por menciones específicas
      if (messageLower.includes(service.name.toLowerCase())) {
        score += 5;
      }

      // Actualizar mejor coincidencia
      if (score > highestScore && score >= 2) {
        highestScore = score;
        bestMatch = service;
      }
    });

    console.log(`🔍 Detección de servicio - Mejor coincidencia: ${bestMatch?.name} (Puntuación: ${highestScore})`);
    return bestMatch;
  };

  // DETECTAR INTENCIÓN DEL USUARIO
  const detectUserIntent = (userMessage) => {
    const message = userMessage.toLowerCase();
    
    const intents = {
      greeting: /(hola|buenos|buenas|hey|hi|qué tal)/i,
      serviceInfo: /(información|info|qué es|para qué sirve|cómo funciona|qué hace)/i,
      pricing: /(precio|costo|cuánto cuesta|valor|cotización|presupuesto)/i,
      implementation: /(cómo instalar|implementar|instalación|montar|configurar)/i,
      comparison: /(diferencia|comparar|vs|mejor|cuál es mejor)/i,
      technical: /(técnico|especificación|característica|tecnología|hardware|software)/i,
      urgency: /(urgente|rápido|inmediato|ya|pronto|cuanto antes)/i
    };

    const detectedIntents = [];
    for (const [intent, regex] of Object.entries(intents)) {
      if (regex.test(message)) {
        detectedIntents.push(intent);
      }
    }

    return detectedIntents.length > 0 ? detectedIntents : ['general'];
  };

  // Enviar a WhatsApp
  const openWhatsApp = (service = null) => {
    const phoneNumber = "573001234567";
    const defaultMessage = "Hola, me interesa obtener información sobre los servicios de Domótica Company.";
    const message = service ? service.whatsappMessage : defaultMessage;
    
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  // Navegar a la página del servicio
  const navigateToService = (service) => {
    if (service && service.route) {
      window.open(service.route, '_blank');
    }
  };

  // PROMPT SUPER MEJORADO PARA RESPUESTAS MÁS INTELIGENTES
  const getSystemPrompt = () => `Eres "Domotic", un asistente virtual especializado en domótica y soluciones tecnológicas. Tu personalidad es amigable, conversacional y entusiasta sobre la tecnología.

INFORMACIÓN CRÍTICA:
• Empresa: Domótica Company - Líderes en soluciones tecnológicas integrales
• Creado por: SecHat Technologies (CEO: Alberto Valencia) - https://sec-hat.com
• Servicios: 12 servicios especializados en tecnología

DETALLES DE SERVICIOS:
${SERVICES_DATA.map(service => `
• ${service.name}: 
  - Descripción: ${service.description}
  - Beneficios: ${service.benefits?.join(', ')}
  - Casos de uso: ${service.useCases?.join(', ')}
`).join('\n')}

ESTRATEGIA DE CONVERSACIÓN INTELIGENTE:

1. DETECCIÓN DE NECESIDADES:
   - Pregunta sobre el contexto (casa, negocio, empresa)
   - Identifica el presupuesto implícito
   - Detecta urgencia en la consulta
   - Comprende necesidades específicas

2. RESPUESTAS CONTEXTUALES:
   - Si es residencial: enfócate en beneficios para hogar, facilidad de uso
   - Si es comercial: destaca ROI, productividad, eficiencia
   - Si es empresarial: resalta escalabilidad, seguridad, integración

3. MANEJO DE OBJECIONES COMUNES:
   - "Es muy caro": Destaca ahorro a largo plazo, financiamiento
   - "No sé si funciona": Menciona casos de éxito, garantías
   - "Es complicado": Enfatiza facilidad de uso, soporte

4. FLUJO DE CONVERSACIÓN NATURAL:
   - Saludo cálido y personalizado
   - Preguntas abiertas para entender necesidades
   - Explicaciones claras y ejemplos concretos
   - Resumen de beneficios clave
   - Llamado a la acción suave

5. TONO Y ESTILO:
   - Amigable pero profesional
   - Entusiasta sobre la tecnología
   - Empatía con las preocupaciones del usuario
   - Uso moderado de emojis (2-3 por respuesta)
   - Lenguaje claro, evitando tecnicismos innecesarios

6. MANEJO DE CONSULTAS TÉCNICAS:
   - Explicar conceptos complejos de forma simple
   - Usar analogías cuando sea útil
   - Proporcionar ejemplos prácticos
   - Ofrecer opciones según nivel técnico del usuario

EJEMPLOS DE DIÁLOGOS EXITOSOS:

Usuario: "necesito cámaras para mi casa"
Tú: "¡Excelente elección! 🏠 Las cámaras de seguridad son perfectas para proteger tu hogar. Te recomiendo nuestro sistema de SEGURIDAD ELECTRÓNICA que incluye cámaras HD con visión nocturna y acceso desde tu celular. ¿Es para el interior, exterior o ambos? Así te puedo recomendar el paquete ideal 😊"

Usuario: "qué tan caro es la energía solar"
Tú: "¡Es más accesible de lo que piensas! ☀️ La energía solar tiene una inversión inicial que se recupera normalmente en 2-3 años, y luego disfrutas de ahorros del 70-80% en tu factura de luz. ¿Es para tu casa o negocio? El costo varía según el consumo, pero tenemos opciones desde planes básicos hasta sistemas completos 💡"

Usuario: "cómo funciona la automatización"
Tú: "¡Es fascinante! 🤖 Imagina controlar luces, clima, seguridad y entretenimiento desde una sola app. Por ejemplo, puedes programar que las luces se enciendan cuando llegas a casa, o que el aire acondicionado se active antes de tu llegada. ¿Te interesa más para hogar o empresa? Cada sistema lo personalizamos según tus necesidades ✨"

RECUERDA: Tu objetivo es entender las necesidades reales del usuario, educar sobre las soluciones disponibles y guiar suavemente hacia la acción apropiada.`;

  // FUNCIÓN MEJORADA PARA DEEPSEEK CON MEMORIA DE CONTEXTO
  const sendToDeepSeek = async (userMessage) => {
    try {
      console.log('🚀 Enviando a DeepSeek API con contexto...');
      
      const detectedService = detectService(userMessage);
      const userIntents = detectUserIntent(userMessage);
      
      console.log('🎯 Intenciones detectadas:', userIntents);
      console.log('🔍 Servicio detectado:', detectedService?.name);

      // Construir mensajes con contexto
      const contextMessages = [
        {
          role: 'system',
          content: getSystemPrompt()
        },
        {
          role: 'system',
          content: `CONTEXTO ACTUAL: ${ChatContextManager.getContextSummary()}`
        },
        ...messages.slice(-6).map(msg => ({
          role: msg.role,
          content: msg.content
        })),
        {
          role: 'user',
          content: userMessage
        }
      ];

      const response = await fetch(DEEPSEEK_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${DEEPSEEK_API_KEY}`
        },
        body: JSON.stringify({
          model: 'deepseek-chat',
          messages: contextMessages,
          max_tokens: 1200,
          temperature: 0.8,
          presence_penalty: 0.1,
          frequency_penalty: 0.1
        })
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response:', errorText);
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }

      const data = await response.json();
      console.log('✅ Respuesta de DeepSeek recibida');
      
      const assistantResponse = data.choices[0].message.content;
      
      // Actualizar contexto
      ChatContextManager.updateContext(userMessage, assistantResponse, detectedService);
      
      if (detectedService) {
        setDetectedService(detectedService);
      }

      return assistantResponse;

    } catch (error) {
      console.error('❌ Error DeepSeek:', error);
      return getFallbackResponse(userMessage);
    }
  };

  // RESPUESTA DE FALLBACK MEJORADA
  const getFallbackResponse = (userMessage) => {
    const messageLower = userMessage.toLowerCase();
    const detectedService = detectService(userMessage);
    
    // Respuestas específicas para preguntas comunes
    if (messageLower.includes('quién te creó') || messageLower.includes('quien te creo')) {
      return "¡Buena pregunta! 😊 Soy Domotic, creado por el talentoso equipo de **SecHat Technologies**. Nuestro fundador es **Alberto Valencia**, un apasionado de la tecnología que quería hacer la domótica accesible para todos. Si quieres conocer más sobre nuestro trabajo, visita https://sec-hat.com 🚀";
    }
    
    if (messageLower.includes('qué servicios') || messageLower.includes('que servicios')) {
      return `¡Tenemos un montón de opciones! 😄 Ofrecemos **12 servicios** especializados:\n\n` +
        SERVICES_DATA.map(service => `• **${service.name}**: ${service.description.split('.')[0]}`).join('\n') +
        `\n\n¿Hay alguno que te llame especialmente la atención? Podemos profundizar en sus beneficios específicos 💡`;
    }
    
    if (detectedService) {
      setDetectedService(detectedService);
      return `¡Perfecto! 👋 Me da mucho gusto que preguntes por **${detectedService.name}**. \n\n${detectedService.description}\n\n**Beneficios principales:**\n${detectedService.benefits?.map(b => `✓ ${b}`).join('\n')}\n\n¿Te gustaría saber sobre precios, instalación o ver casos de éxito? 😊`;
    }
    
    // Respuesta genérica mejorada
    return `¡Hola! 👋 Soy Domotic, tu asistente especializado en soluciones tecnológicas. 

Me encanta ayudar a las personas y empresas a encontrar la tecnología perfecta para sus necesidades. Tenemos **${SERVICES_DATA.length} servicios** diferentes, desde automatización de hogares hasta energía solar y sistemas de seguridad avanzados.

¿Podrías contarme un poco más sobre lo que necesitas? Por ejemplo:
• ¿Es para tu casa, negocio o empresa?
• ¿Qué problema te gustaría resolver?
• ¿Tienes algún presupuesto en mente?

¡Estoy aquí para ayudarte a encontrar la mejor solución! 😊`;
  };

  const handleSendMessage = async () => {
    if (!inputMessage.trim() || isLoading) return;

    const userMessage = inputMessage.trim();
    setInputMessage('');
    
    const userMsg = { 
      role: 'user', 
      content: userMessage, 
      timestamp: new Date() 
    };
    setMessages(prev => [...prev, userMsg]);
    setIsLoading(true);
    setShowWelcome(false);

    try {
      const assistantResponse = await sendToDeepSeek(userMessage);
      const assistantMsg = {
        role: 'assistant',
        content: assistantResponse,
        timestamp: new Date()
      };
      setMessages(prev => [...prev, assistantMsg]);
      
      // Avanzar en el flujo de conversación
      if (conversationStep === 'initial' && messages.length >= 1) {
        setConversationStep('qualifying');
      }
      
    } catch (error) {
      console.error('Error:', error);
      const errorMsg = {
        role: 'assistant',
        content: '¡Ups! 🔧 Parece que estoy teniendo un problema técnico momentáneo. ¿Podrías intentarlo de nuevo en un momentito? Mientras tanto, ¿hay algún servicio específico que te interese? 😊',
        timestamp: new Date()
      };
      setMessages(prev => [...prev, errorMsg]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const clearChat = () => {
    setMessages([]);
    setDetectedService(null);
    setShowWelcome(true);
    setConversationStep('initial');
    ChatContextManager.resetContext();
  };

  const handleSuggestionClick = (question) => {
    setInputMessage(question);
    setTimeout(() => {
      handleSendMessage();
    }, 300);
  };

  // COMPONENTE MEJORADO PARA SERVICIOS DETECTADOS
  const ServiceActions = ({ service }) => (
    <div className="message assistant-message">
      <div className="message-content">
        <div className="action-buttons-container">
          <p className="action-title">💡 <strong>¿Te interesa {service.name}?</strong></p>
          <p>Tenemos más información detallada y nuestro equipo está listo para ayudarte:</p>
          
          <div className="service-details">
            <div className="service-benefits">
              <strong>Beneficios:</strong>
              <div className="benefits-grid">
                {service.benefits?.map((benefit, index) => (
                  <span key={index} className="benefit-tag">✓ {benefit}</span>
                ))}
              </div>
            </div>
            
            <div className="service-use-cases">
              <strong>Perfecto para:</strong>
              <div className="use-cases-grid">
                {service.useCases?.map((useCase, index) => (
                  <span key={index} className="use-case-tag">🏢 {useCase}</span>
                ))}
              </div>
            </div>
          </div>
          
          <div className="action-buttons-grid">
            <button 
              className="action-button primary"
              onClick={() => navigateToService(service)}
            >
              🌐 Ver página completa del servicio
            </button>
            <button 
              className="action-button secondary"
              onClick={() => openWhatsApp(service)}
            >
              📱 Contactar por WhatsApp
            </button>
            <button 
              className="action-button tertiary"
              onClick={() => handleSuggestionClick(`Necesito más información sobre ${service.name}`)}
            >
              ❓ Más información técnica
            </button>
          </div>
          
          <p className="action-subtitle">¡Estamos aquí para asesorarte 24/7! 😊</p>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {/* BURBUJA DE BIENVENIDA */}
      {showWelcome && !isOpen && (
        <div className="welcome-bubble">
          <div className="bubble-content">
            <p>👋 ¡Hola! Soy Domotic, tu asistente IA</p>
            <p>¿Necesitas ayuda con nuestros servicios tecnológicos?</p>
          </div>
          <div className="bubble-arrow"></div>
        </div>
      )}

      {/* BOTÓN CON CHIP IA MEJORADO */}
      <button 
        onClick={() => {
          setIsOpen(true);
          setShowWelcome(false);
        }}
        className="chatbot-floating-btn"
      >
        <div className="ai-chip-icon">
          <span className="chip-text">IA</span>
        </div>
        <span>Domotic</span>
      </button>

      {/* CHATBOX MEJORADO */}
      {isOpen && (
        <div className="chatbot-container open">
          {/* Header */}
          <div className="chatbot-header">
            <div className="header-content">
              <div className="ai-chip-icon header-icon">
                <span className="chip-text">IA</span>
              </div>
              <div className="header-info">
                <h3>DOMOTIC - IA Assistant</h3>
                <span className="status">En línea 24/7 • Especialista en tecnología</span>
              </div>
            </div>
            <div className="header-actions">
              <button className="action-btn" onClick={clearChat} title="Nueva conversación">
                ↻
              </button>
              <button className="action-btn" onClick={() => setIsOpen(false)} title="Cerrar">
                ×
              </button>
            </div>
          </div>

          {/* Mensajes */}
          <div className="messages-container">
            {messages.length === 0 && (
              <div className="welcome-message">
                <div className="message assistant-message">
                  <div className="message-content">
                    <div className="message-text">
                      <p>¡Hola! 👋 Soy <strong>Domotic</strong>, tu asistente especializado en soluciones tecnológicas.</p>
                      <p>Me encanta conectar a las personas con la tecnología perfecta para sus necesidades. ¿En qué puedo ayudarte hoy? 😊</p>
                      
                      <div className="services-showcase">
                        <p><strong>Nuestros 12 servicios especializados:</strong></p>
                        <div className="services-grid">
                          {SERVICES_DATA.map(service => (
                            <span key={service.name} className="service-tag" title={service.description}>
                              {service.name}
                            </span>
                          ))}
                        </div>
                      </div>
                      
                      <p>Puedes preguntarme sobre precios, instalación, beneficios técnicos, o comparar servicios. ¡Estoy aquí para ayudarte! 💡</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {messages.map((message, index) => (
              <div
                key={index}
                className={`message ${message.role === 'user' ? 'user-message' : 'assistant-message'}`}
              >
                <div className="message-content">
                  <div className="message-text">
                    {message.content.split('\n').map((line, i) => (
                      <p key={i}>{line}</p>
                    ))}
                  </div>
                  <div className="message-time">
                    {message.timestamp.toLocaleTimeString('es-ES', { 
                      hour: '2-digit', 
                      minute: '2-digit' 
                    })}
                  </div>
                </div>
              </div>
            ))}
            
            {/* ACCIONES MEJORADAS CUANDO SE DETECTA UN SERVICIO */}
            {detectedService && (
              <ServiceActions service={detectedService} />
            )}
            
            {isLoading && (
              <div className="message assistant-message">
                <div className="loading-indicator">
                  <div className="loading-dot"></div>
                  <div className="loading-dot"></div>
                  <div className="loading-dot"></div>
                  <span>Domotic está analizando tu consulta...</span>
                </div>
              </div>
            )}
            
            <div ref={messagesEndRef} />
          </div>

          {/* SUGERENCIAS MEJORADAS Y CONTEXTUALES */}
          <div className="suggestions-container">
            <div className="suggestions-label">
              {messages.length === 0 ? "¿Por dónde quieres empezar? 💡" : "¿Necesitas más información? 🚀"}
            </div>
            <div className="suggestions-grid">
              {messages.length === 0 ? (
                <>
                  <button 
                    className="suggestion-chip" 
                    onClick={() => handleSuggestionClick("Necesito cámaras de seguridad para mi casa")}
                  >
                    📹 Seguridad Residencial
                  </button>
                  <button 
                    className="suggestion-chip" 
                    onClick={() => handleSuggestionClick("Quiero energía solar para ahorrar en luz")}
                  >
                    ☀️ Energía Solar
                  </button>
                  <button 
                    className="suggestion-chip" 
                    onClick={() => handleSuggestionClick("Necesito automatización para mi empresa")}
                  >
                    🤖 Automatización Empresarial
                  </button>
                </>
              ) : (
                <>
                  <button 
                    className="suggestion-chip" 
                    onClick={() => handleSuggestionClick("¿Qué incluye la instalación?")}
                  >
                    🔧 Instalación
                  </button>
                  <button 
                    className="suggestion-chip" 
                    onClick={() => handleSuggestionClick("¿Tienen financiamiento?")}
                  >
                    💰 Precios y Financiamiento
                  </button>
                  <button 
                    className="suggestion-chip" 
                    onClick={() => handleSuggestionClick("¿Qué garantía ofrecen?")}
                  >
                    🛡️ Garantías
                  </button>
                </>
              )}
            </div>
          </div>

          {/* Input */}
          <div className="input-container">
            <div className="input-wrapper">
              <textarea
                value={inputMessage}
                onChange={(e) => setInputMessage(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Escribe tu pregunta o lo que necesites..."
                rows="2"
                disabled={isLoading}
                className="message-input"
              />
              <button 
                onClick={handleSendMessage}
                disabled={isLoading || !inputMessage.trim()}
                className="send-button"
              >
                <span className="send-icon">➤</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DomoticChatbot;